import { Component, Vue } from 'vue-property-decorator';
import WithRender from './agentmonthlysales.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';

@WithRender
@Component({
  components: {
    Loading
  }
})
export default class AgentMonthlySales extends Vue {
  isLoading = false;

  month = new Date().getMonth() + 1;
  year = new Date().getFullYear();

  perPage = 100;
  currentPage = 1;
  selectedPage = 1;
  totalRecords = 0;

  items = [];
  fields = [
   {
      key: "transactions",
      label: "Transactions",
      sortable: true,
    },
    {
      key: "agentFee",
      label: "Agent Fee",
      sortable: true,
    },
    {
      key: "umbaiFee",
      label: "Umbai Fee",
      sortable: true,
    },
    {
      key: "fullName",
      label: "Name",
      sortable: true,
    },
    {
      key: "userEmail",
      label: "Email",
      sortable: true,
    },
    {
      key: "stateOrProvince",
      label: "Province",
      sortable: true,
    },
    {
      key: "postalCode",
      label: "Postal Code",
      sortable: true,
    },
    {
      key: "streetAddress",
      label: "Street Address",
      sortable: true,
    },
    {
      key: "totalAmount",
      label: "Total Amount",
      sortable: true,
    },
    { key: "referror",        label: "Referror",       sortable: true },
    {
      key: "userId",
      label: "",
    }
  ]

  mounted() {
    this.getReport();
  }

  handlePageClick() {
    if (this.currentPage === this.selectedPage)
      return;
    this.currentPage = this.selectedPage;
    this.getReport();
  }

  getReport(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}admin/internal/report/AgentMonthlySales?month=${this.month}&year=${this.year}&currentPage=${this.currentPage}&pageSize=${this.perPage}`)
      .then(response => {
        this.items = response.data.objectList;
        this.totalRecords = response.data.totalRowCount;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }

    downloadCsv(): void {
    _axios.get(`${config.gateway}admin/internal/report/AgentMonthlySales/GetCSV?month=${this.month}&year=${this.year}`
      , { responseType: 'blob' })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = `AgentMonthlySales-${this.month}-${this.year}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch(err => { console.error(err); });
  }
}
